import React from 'react';
import CRMEquipeVendasConfigModal from './CRMEquipeVendasConfigModal';

export default function MarketingCampaignEquipeVendasConfigModal(props) {
  return <CRMEquipeVendasConfigModal {...props} />;
}
